import { render, staticRenderFns } from "./ActionMessage.vue?vue&type=template&id=5d3a9ddb&scoped=true&"
import script from "./ActionMessage.vue?vue&type=script&lang=js&"
export * from "./ActionMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3a9ddb",
  null
  
)

export default component.exports